{
  "HeaderSidebar_ExpandMenu": "Menü erweitern (Strg + ])",
  "HeaderSidebar_CollapseMenu": "Menü reduzieren (Strg + [)",
  "HeaderSidebar_PinMenu": "Pin-Menü erweitert",
  "HeaderSidebar_UnpinMenu": "Menü „Unpin“ (Abheften)",
  "NAME": "HeaderSidebar"
}